
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-menu/[cName]",
      function () {
        return require("private-next-pages/embedded-menu/[cName].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embedded-menu/[cName]"])
      });
    }
  